if (!customElements.get('pack-product-form')) {
    customElements.define("pack-product-form", class ProductForm extends HTMLElement {
      constructor() {
        super();
  
        this.form = this.querySelector('form');
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.selectedProducts = [];
        this.currentProduct = this.querySelector("input.product-variant-id");
        this.inputs = Array.from(this.querySelectorAll('input[type="radio"]'));
        this.inputs.forEach(input => input.addEventListener('change', this.onInputChange.bind(this)));

        this.submitBanner = document.getElementById("ProductSubmitButton-banner-pack");
        if (this.submitBanner && this.submitButton) {
          this.submitBanner.addEventListener("click", () => {
            this.submitButton.click();
          })
        }
        
  
        this.addEventListener("PackChange", (e) => {
          e.stopImmediatePropagation();
          this.selectedProducts = [];
          if (e.detail && e.detail.variantid) {
            this.selectedProducts[e.detail.variantid] = e.detail.quantity;
            if (e.detail.quantity <= 0) {
              delete this.selectedProducts[e.detail.variantid];
            }
          }
        
        });
  
        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
      }

      onInputChange(event) {
        const selectedInput = event.target.closest(".product__pack-item").querySelector("input");
        selectedInput.checked = true;
        if (selectedInput.classList.contains("js-current")) {
          this.dispatchEvent(new CustomEvent("PackChange"));
        } else {
          const variantId = selectedInput.dataset.id;
  
          const updateEvent = new CustomEvent("PackChange", {
          detail: {
              variantid: variantId,
              quantity: 1
          }
          });
          this.dispatchEvent(updateEvent);
        }
      }
  
      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
  
        this.handleErrorMessage();
  
        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        config.headers['Content-Type'] = "application/json";
  
        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
  
        let showErrorMessage = false;
        let uniqueProducts = Object.entries(this.selectedProducts).map(([key, value]) => ({
            id: key,
            quantity: value
        }));
        
        if (this.currentProduct && this.currentProduct.value) {
            uniqueProducts.push({
                id: this.currentProduct.value,
                quantity: 1
            });
        }
        let packProducts = {
            items: uniqueProducts
        };
  
        for (const pair of formData.entries()) {
            if (pair[0] == 'id' || pair[0] == 'quantity') continue;
            packProducts[pair[0]] = pair[1]
        }
  
        config.body = JSON.stringify(packProducts);
        if (showErrorMessage == false) {
            fetch(`${routes.cart_add_url}`, config)
            .then((response) => response.json())
            .then((response) => {
                if (response.status) {
                this.handleErrorMessage(response.description);
  
                const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
                if (!soldOutMessage) return;
                this.submitButton.setAttribute('aria-disabled', true);
                this.submitButton.querySelector('span').classList.add('hidden');
                soldOutMessage.classList.remove('hidden');
                this.error = true;
                return;
                } else if (!this.cart) {
                window.location = window.routes.cart_url;
                return;
                }
  
                if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form' });
                this.error = false;
                const quickAddModal = this.closest('quick-add-modal');
                if (quickAddModal) {
                document.body.addEventListener('modalClosed', () => {
                    setTimeout(() => { this.cart.renderContents(response) });
                }, { once: true });
                quickAddModal.hide(true);
                } else {
                this.cart.renderContents(response);
                }
            })
            .catch((e) => {
                console.error(e);
            })
            .finally(() => {
                this.submitButton.classList.remove('loading');
                if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
                if (!this.error) this.submitButton.removeAttribute('aria-disabled');
                this.querySelector('.loading-overlay__spinner').classList.add('hidden');
            });
        } else {
            this.querySelector(".product-form__error-message-wrapper").removeAttribute("hidden");
            this.submitButton.classList.remove('loading');
            this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        }
      }
  
      handleErrorMessage(errorMessage = false) {
        this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');
  
        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
  
        if (errorMessage) {
            this.errorMessage.textContent = errorMessage;
        }
      }
  
    });
  }
